module.exports = __webpack_public_path__ + "static/img/sy_t6_tp.2da677a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/sy_t6_tp.png
// module id = UAJZ
// module chunks = 16